import { action } from "satcheljs";

const composePlainTextContentInserted = action("composePlainTextContentInserted", (composeId: string, changeSource: string) => ({ composeId, changeSource }));

export default composePlainTextContentInserted;
